export default "__VITE_ASSET__3ce5a530__"